var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: "", shrink: "" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("closed-periods")))]),
      _c(
        "w-list",
        _vm._l(_vm.periods, function (period) {
          return _c(
            "w-list-item",
            { key: period.AccountingPeriod },
            [
              _c("w-list-item-text", [_vm._v(_vm._s(period.getText()))]),
              _c(
                "w-list-item-action",
                [
                  _c("w-switch", {
                    attrs: { value: _vm.isPeriodClosed(period) },
                    on: {
                      input: function ($event) {
                        return _vm.togglePeriod(period, $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }